import React from "react";

// Hooks
import { useFooterType } from "../../overrides/venia-ui/components/Footer/footer";
import { useHeaderType } from "../../overrides/venia-ui/components/Header/header";

//Assets
import { SchemaRestaurant } from "@Components/SchemaOrg/SchemaRestaurant";
import { Meta, Title } from "@magento/venia-ui/lib/components/Head";
import StoreDetails from "@Components/StoreDetails";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import Header from "@Components/BookTable/Header";
import { isOrderActive } from "@Components/LinkBetween/miScusiAndTakeAwayUtils";
var StoreDetailsPage = _ref => {
  var {
    store,
    backFunction
  } = _ref;
  var {
    isMobile
  } = useWindowSize();
  useHeaderType(isMobile && isOrderActive ? "hidden" : isMobile ? "default-white" : "default-red");
  useFooterType("hidden");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SchemaRestaurant, {
    store: store
  }), /*#__PURE__*/React.createElement(Title, null, store.meta_title), /*#__PURE__*/React.createElement(Meta, {
    name: "title",
    content: store.meta_title
  }), /*#__PURE__*/React.createElement(Meta, {
    name: "description",
    content: store.meta_description
  }), /*#__PURE__*/React.createElement(Meta, {
    name: "keywords",
    content: store.meta_keywords
  }), isMobile && isOrderActive ? /*#__PURE__*/React.createElement(Header, {
    goBack: backFunction,
    title: store.frontend_name
  }) : null, /*#__PURE__*/React.createElement(StoreDetails, {
    store: store,
    backFunction: backFunction
  }));
};
export default StoreDetailsPage;